/* istanbul ignore file */
import { connect } from 'react-redux'
import Resume from './Resume'
import { bookingDataSelector, buildBookingIsLoadingSelector, updateBookingIsLoadingSelector } from 'rental-car-contract/js/selectors/booking'
import { ratesDataSelector } from 'rental-car-contract/js/selectors/rates'
import { userIsLoggedInSelector } from 'rental-car-contract/js/selectors/user'

function mapStateToProps (state) {
    const booking = bookingDataSelector(state) || {}
    const rates = ratesDataSelector(state) || {}
    return {
        id: booking.id,
        rate: booking.rate,
        priceDetails: booking.priceDetails,
        features: booking.features,
        startDate: booking.startDate,
        endDate: booking.endDate,
        price: booking.price,
        originPOI: booking.originPOI,
        destinationPOI: booking.destinationPOI,
        loading: updateBookingIsLoadingSelector(state),
        isMutuaUser: rates.isMutuaUser || userIsLoggedInSelector(state),
        buildBookingLoading: buildBookingIsLoadingSelector(state),
        additionalInfoUrl: booking.additionalInfoUrl,
    }
}

export default connect(mapStateToProps)(Resume)
